import { Dispatch } from 'redux';
import { LoginService } from '../../services/LoginService';
 import { Admin_API, PATIENT_API } from '../../ApiNames';



export const fetchPieChartDataSuccess = (pieChartData: any,piechartOptions: any) => ({
    type: 'FETCH_PIE_CHART_DATA_SUCCESS',
    payload: {pieChartData,piechartOptions}
});
export const fetchDonorChartDataSuccess = (donorChartData: any,donorrchartOptions:any) => ({
    type: 'FETCH_Donor_CHART_DATA_SUCCESS',
    payload: {donorChartData,donorrchartOptions}
});




export const fetchPieChartData = (uid:any) => {
    return async (dispatch: Dispatch) => {
            try {
                const payload = { userid:uid,q: 5 };
                const apiname = PATIENT_API.patientdashboard_API;
                const response = await LoginService.getData(apiname,payload);
                if (Array.isArray(response) && response.length > 0) {
                    const documentStyle = getComputedStyle(document.documentElement);
                    const labels = response.map(item => item.label); 
                    const values = response.map(item => item.value);
                    const data = {
                        labels: labels,
                        datasets: [
                            {
                               data: values
                            }
                        ]
                    }
                    const options = {
                        plugins: {
                            legend: {
                                labels: {
                                    usePointStyle: true
                                }
                            }
                        }
                    };
                    dispatch(fetchPieChartDataSuccess(data, options));
                }
            } catch (error) {
                console.error('Error fetching chart data:', error);
            }
    };
};
//To get bar chart data
export const fetchDonorChartData = (uid:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = { userid:uid,q: 6 };
            const apiname = PATIENT_API.patientdashboard_API;
            const response = await LoginService.getData(apiname,payload);
            if (Array.isArray(response) && response.length > 0) {
              const labels = response.map(item => item.label); 
              const values = response.map(item => item.value);
              const data = {
                labels: labels,
                datasets: [
                  {
                    label:'Members',
                    data: 
                      values
                    ,
                    backgroundColor: [
                      'rgba(255, 159, 64, 0.2)',
                      'rgba(75, 192, 192, 0.2)',
                      'rgba(54, 162, 235, 0.2)',
                      'rgba(153, 102, 255, 0.2)',
                    ],
                    borderColor: [
                      'rgb(255, 159, 64)',
                      'rgb(75, 192, 192)',
                      'rgb(54, 162, 235)',
                      'rgb(153, 102, 255)',
                    ],
                    borderWidth: 1,
                    barThickness: 70,         
                    maxBarThickness: 80,     
                    minBarLength: 2 
                  },
                ],
              };
              const options = {
                responsive: true,
                maintainAspectRatio: false,
                scales: {
                  y: {
                    beginAtZero: true,
                  },
                },
              };
              
              dispatch(fetchDonorChartDataSuccess(data, options));
            }
          } catch (error) {
            console.error('Error fetching chart data:', error);
          }

    };
};



